import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ServiceThemeProvider } from "@/context/ServiceThemeContext";
import { useLenis } from "@/hooks/useLenis";
import CustomCursor from "@/components/cursor/CustomCursor";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Services from "@/components/sections/Services";
import Showcase from "@/components/sections/Showcase";
import HowItWorks from "@/components/sections/HowItWorks";
import LivingURL from "@/components/sections/LivingURL";
import Testimonials from "@/components/sections/Testimonials";
import CtaFooter from "@/components/sections/CtaFooter";

const LandingPage = () => (
  <>
    <CustomCursor />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Showcase />
      <HowItWorks />
      <LivingURL />
      <Testimonials />
      <CtaFooter />
    </main>
  </>
);

function App() {
  useLenis();
  return (
    <ServiceThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </ServiceThemeProvider>
  );
}

export default App;
